import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DropdownObject } from '@inmoment/the-kitchen';

import { AppSharedModule } from 'app/app-shared.module';
import { Comparison } from 'app/providers/bridge-api/dashboard.service';
import {
  EnableClassTelemetry,
  EnableComponentTelemetry,
  injectComponentTelemetryService,
} from 'app/services/otel.service';

@EnableClassTelemetry()
@Component({
  selector: 'app-comparison-chooser',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [AppSharedModule],
  templateUrl: './comparison-chooser.component.html',
  styleUrls: ['./comparison-chooser.component.scss'],
})
export class ComparisonChooserComponent implements OnInit {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();

  @Input() comparisons: Comparison[];

  @Output() close = new EventEmitter<string | null>();

  form: UntypedFormGroup;

  ds: DropdownObject[];

  constructor(formBuilder: UntypedFormBuilder) {
    this.form = formBuilder.group({
      id: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.ds = this.comparisons.map((c) => ({ id: c.id, title: c.title }));
  }

  onAdd(): void {
    this.close.emit(this.form.controls.id.value);
  }

  onCancel(): void {
    this.close.emit(null);
  }
}
